import project_2 from "../Images/project_2.jpg";
import project_1 from "../Images/project_1.jpg";
import project_3 from "../Images/project_3.jpg";
import project_4 from "../Images/project_4.jpg";
import project_5 from "../Images/project_5.jpg";
import project_6 from "../Images/project_6.jpg";
import project_7 from "../Images/project_7.jpg";
import project_8 from "../Images/project_8.jpg";
import project_9 from "../Images/project_9.jpg";
import project_10 from "../Images/project_10.jpg";
import project_11 from "../Images/project_11.jpg";
import project_12 from "../Images/project_12.jpg";
import project_13 from "../Images/project_13.jpg";
import project_14 from "../Images/project_14.jpeg";
import project_15 from "../Images/project_15.jpeg";
import project_16 from "../Images/project_16.jpeg";
import project_17 from "../Images/project_17.jpg";
import project_18 from "../Images/project_18.jpg";
import { CgPlayListAdd } from "react-icons/cg";
import { CiInboxIn } from "react-icons/ci";
import { MdWorkHistory } from "react-icons/md";
import { GrInProgress } from "react-icons/gr";
import { ImProfile } from "react-icons/im";
import { IoIosLogOut } from "react-icons/io";

export const projectData = [
  {
    id: 1,
    project_img: project_2,
  },

  {
    id: 2,
    project_img: project_1,
  },

  {
    id: 3,
    project_img: project_3,
  },

  {
    id: 4,
    project_img: project_4,
  },

  {
    id: 5,
    project_img: project_5,
  },

  {
    id: 6,
    project_img: project_6,
  },

  {
    id: 7,
    project_img: project_7,
  },

  {
    id: 8,
    project_img: project_8,
  },

  {
    id: 9,
    project_img: project_9,
  },

  {
    id: 10,
    project_img: project_10,
  },

  {
    id: 11,
    project_img: project_11,
  },

  {
    id: 12,
    project_img: project_12,
  },

  {
    id: 13,
    project_img: project_13,
  },

  {
    id: 14,
    project_img: project_14,
  },

  {
    id: 15,
    project_img: project_15,
  },

  {
    id: 16,
    project_img: project_16,
  },

  {
    id: 17,
    project_img: project_17,
  },

  {
    id: 18,
    project_img: project_18,
  },
];

export const TestimonialData = [
  {
    id: 1,
    title:
      "I engaged the service of PMC limited for the drain unblocking service and i got a professional service delivery",
    name: "Amanda Lee",
  },

  {
    id: 2,
    title:
      "Great customer service and great job done, i was wowed by the service delivery of PMC limited",
    name: "C. Franklin",
  },

  {
    id: 3,
    title:
      "PMC Limited simply the best i will recommend them to anyone who is in search of good service delivery",
    name: "Catherine Gilbert",
  },
];

export const aboutData = [
  {
    id: 1,
    title: "Vision",
    desc: "To be a leading provider of quality, innovative, and reliable services to our esteemed customers, and to be the single point of reference for all building-related works.",
  },

  {
    id: 2,
    title: "Mission",
    desc: "To empower and support our staff and the communities in which we operate, and in doing so, help our stakeholders realize their potential.",
  },
  {
    id: 3,
    title: "Values",
    desc: "To deliver on our promises through a commitment to integrity, teamwork, respect, and an innovative attitude in our operations.",
  },
];

export const dashboardData = [
  {
    id: 1,
    path: "new-request",
    name: "New Request",
    icon: <CgPlayListAdd />,
  },

  {
    id: 2,
    path: "/dashboard",
    name: "Inbox",
    icon: <CiInboxIn />,
  },

  {
    id: 3,
    path: "service-history",
    name: "Service History",
    icon: <MdWorkHistory />,
  },

  {
    id: 4,
    path: "job-progress",
    name: "Job Progress",
    icon: <GrInProgress />,
  },

  {
    id: 5,
    path: "manage-profile",
    name: "Manage Profile",
    icon: <ImProfile />,
  },
];

export const adminDashboardData = [
  {
    id: 1,
    path: "/admin-dashboard",
    name: "Get Request",
    icon: <CgPlayListAdd />,
  },
  {
    id: 2,
    path: "inbox-admin",
    name: "Inbox",
    icon: <CiInboxIn />,
  },
  {
    id: 3,
    path: "quotations",
    name: "Quotations",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 32 32"
      >
        <path
          fill="black"
          d="M19.307 3.21a2.91 2.91 0 1 0-.223 1.94a11.636 11.636 0 0 1 8.232 7.049l1.775-.698a13.576 13.576 0 0 0-9.784-8.291m-2.822 1.638a.97.97 0 1 1 0-1.939a.97.97 0 0 1 0 1.94m-4.267.805l-.717-1.774a13.576 13.576 0 0 0-8.291 9.784a2.91 2.91 0 1 0 1.94.223a11.636 11.636 0 0 1 7.068-8.233m-8.34 11.802a.97.97 0 1 1 0-1.94a.97.97 0 0 1 0 1.94m12.607 8.727a2.91 2.91 0 0 0-2.599 1.62a11.636 11.636 0 0 1-8.233-7.05l-1.774.717a13.576 13.576 0 0 0 9.813 8.291a2.91 2.91 0 1 0 2.793-3.578m0 3.879a.97.97 0 1 1 0-1.94a.97.97 0 0 1 0 1.94M32 16.485a2.91 2.91 0 1 0-4.199 2.599a11.636 11.636 0 0 1-7.05 8.232l.718 1.775a13.576 13.576 0 0 0 8.291-9.813A2.91 2.91 0 0 0 32 16.485m-2.91.97a.97.97 0 1 1 0-1.94a.97.97 0 0 1 0 1.94"
        />
        <path
          fill="black"
          d="M19.19 16.35a3.879 3.879 0 1 0-5.42 0a4.848 4.848 0 0 0-2.134 4.014v1.939h9.697v-1.94a4.848 4.848 0 0 0-2.143-4.014m-4.645-2.774a1.94 1.94 0 1 1 3.88 0a1.94 1.94 0 0 1-3.88 0m-.97 6.788a2.91 2.91 0 1 1 5.819 0z"
          class="ouiIcon__fillSecondary"
        />
      </svg>
    ),
  },

  {
    id: 4,
    path: "subscription",
    name: "Subscription",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 32 32"
      >
        <path
          fill="black"
          d="M19.307 3.21a2.91 2.91 0 1 0-.223 1.94a11.636 11.636 0 0 1 8.232 7.049l1.775-.698a13.576 13.576 0 0 0-9.784-8.291m-2.822 1.638a.97.97 0 1 1 0-1.939a.97.97 0 0 1 0 1.94m-4.267.805l-.717-1.774a13.576 13.576 0 0 0-8.291 9.784a2.91 2.91 0 1 0 1.94.223a11.636 11.636 0 0 1 7.068-8.233m-8.34 11.802a.97.97 0 1 1 0-1.94a.97.97 0 0 1 0 1.94m12.607 8.727a2.91 2.91 0 0 0-2.599 1.62a11.636 11.636 0 0 1-8.233-7.05l-1.774.717a13.576 13.576 0 0 0 9.813 8.291a2.91 2.91 0 1 0 2.793-3.578m0 3.879a.97.97 0 1 1 0-1.94a.97.97 0 0 1 0 1.94M32 16.485a2.91 2.91 0 1 0-4.199 2.599a11.636 11.636 0 0 1-7.05 8.232l.718 1.775a13.576 13.576 0 0 0 8.291-9.813A2.91 2.91 0 0 0 32 16.485m-2.91.97a.97.97 0 1 1 0-1.94a.97.97 0 0 1 0 1.94"
        />
        <path
          fill="black"
          d="M19.19 16.35a3.879 3.879 0 1 0-5.42 0a4.848 4.848 0 0 0-2.134 4.014v1.939h9.697v-1.94a4.848 4.848 0 0 0-2.143-4.014m-4.645-2.774a1.94 1.94 0 1 1 3.88 0a1.94 1.94 0 0 1-3.88 0m-.97 6.788a2.91 2.91 0 1 1 5.819 0z"
          class="ouiIcon__fillSecondary"
        />
      </svg>
    ),
  },

  // {
  //   id: 3,
  //   path: "data",
  //   name: "Data Visualization",
  //   icon: (
  //     <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
  //       <path fill="black" d="M10.25 4.25A.75.75 0 0 1 11 5v8h8a.75.75 0 0 1 .743.648l.007.102c0 4.97-4.03 8.5-9 8.5a9 9 0 0 1-9-9c0-4.97 3.53-9 8.5-9m3-2.5a9 9 0 0 1 9 9a.75.75 0 0 1-.75.75h-8.25a.75.75 0 0 1-.75-.75V2.5a.75.75 0 0 1 .75-.75" />
  //     </svg>
  //   ),
  // },

  {
    id: 5,
    path: "report",
    name: "Report",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
      >
        <path
          fill="black"
          d="M12 17q.425 0 .713-.288T13 16t-.288-.712T12 15t-.712.288T11 16t.288.713T12 17m-1-4h2V7h-2zm-2.75 8L3 15.75v-7.5L8.25 3h7.5L21 8.25v7.5L15.75 21z"
        />
      </svg>
    ),
  },

  {
    id: 6,
    path: "/",
    name: "Logout",
    icon: <IoIosLogOut />,
  },
];
